import React, { Component } from 'react'
import { TextField, InputAdornment, Paper } from '@material-ui/core'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined'
import clsx from 'clsx'

export class Email extends Component {
  render() {
    return (
      <div style={{ display: 'inline-grid' }}>
        <TextField
          style={{
            margin: '6px'
          }}
          label="Email Address"
          name="email"
          type="email"
          id="email"
          value={(this.props.email && this.props.email) || ''}
          placeholder="@beyounds.com"
          margin="dense"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EmailOutlinedIcon fontSize="small" className="icon-color" />
              </InputAdornment>
            )
          }}
          className="text-field-style"
          variant="outlined"
          autoComplete="false"
          onChange={this.props.onChange}
          required
        />
        <Paper
          style={{
            background: 'var(--trasparent)',
            margin: '6px',
            display: 'inline-grid'
          }}
          className={clsx('card-body-color', 'text-color')}>
          {this.props.formErrors.length > 0 && (
            <span
              style={{
                color: 'var(--red)',
                display: 'flex',
                margin: '0',
                padding: '0 6px',
                alignItems: 'center',
                border: '1px solid var(--red)',
                borderRadius: '5px'
              }}
              className="errorMessage">
              <ErrorOutlineOutlinedIcon fontSize="small" />
              {'  '}&nbsp;
              {this.props.formErrors}
            </span>
          )}
        </Paper>
      </div>
    )
  }
}
export default Email
